export var createLabelWithFacetCount = function(facetData, currentOption) {
    var selectedPrice = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, useMonthly = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var label = currentOption.label, value = currentOption.value;
    var valueAsKey = useMonthly ? value * 100 : value;
    var isNotCurrentValue = facetData[valueAsKey] !== undefined && selectedPrice !== value;
    return "".concat(label, " ").concat(isNotCurrentValue ? "(".concat(facetData[valueAsKey].toLocaleString(), ")") : "");
};
